import { useEffect, useRef, useState } from "react";

import PostSectionHeader from "./PostSectionHeader";
import PostSectionFooter from "./PostSectionFooter";
import MentionInput, { MentionInputHandle } from "./mentionInput/MentionInput";
import Message from "../message/Message";
import ImageCarousel from "./ImageCarousel";

import PostSectionContainerStyles from "./PostSectionContainer.module.css";

import { usePostForm } from "../../context/PostFormContext";

const PostInputWrapper = () => {
  const { formPost, message, setMessage, setFormPost } = usePostForm();
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const mentionInputRef = useRef<MentionInputHandle>(null);
  // Ref to the hidden file input inside PostInterAction — used by the carousel's "Add photo" card
  const addMoreInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (formPost?.imagePost && formPost.imagePost.length > 0) {
      const urls = formPost.imagePost.map((file) => URL.createObjectURL(file));
      setImagePreviews(urls);

      return () => {
        urls.forEach((url) => URL.revokeObjectURL(url));
      };
    } else {
      setImagePreviews([]);
    }
  }, [formPost?.imagePost]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, setMessage]);

  const handleRemoveImage = (index: number) => {
    const updatedImages = formPost.imagePost.filter((_, i) => i !== index);
    setFormPost({
      ...formPost,
      imagePost: updatedImages,
    });
  };

  return (
    <div className={PostSectionContainerStyles.postSectionContainerBlk}>
      <PostSectionHeader mentionInputRef={mentionInputRef} />

      <MentionInput ref={mentionInputRef} />

      {message && (
        <div style={{ marginBottom: "10px", marginTop: "10px" }}>
          <Message variant="error">{message}</Message>
        </div>
      )}

      <PostSectionFooter addMoreInputRef={addMoreInputRef} />

      <ImageCarousel
        imagePreviews={imagePreviews}
        totalImages={formPost.imagePost.length}
        onRemove={handleRemoveImage}
        onAddMore={() => addMoreInputRef.current?.click()}
      />
    </div>
  );
};

const PostSectionContainer = () => {
  return <PostInputWrapper />;
};

export default PostSectionContainer;
